module.exports = __webpack_public_path__ + "assets/img/gift-hero-base-402481dd.png";